/**
 * Chatwoot SDK's toggleBubbleVisibility may throw (e.g. classList on null) if the
 * launcher DOM is not mounted yet, even when window.$chatwoot exists.
 */
export function safeToggleChatwootBubble(visibility) {
  if (typeof window.$chatwoot?.toggleBubbleVisibility !== "function") return;

  const run = () => {
    try {
      window.$chatwoot.toggleBubbleVisibility(visibility);
    } catch {
      // SDK not fully ready; ignore
    }
  };

  if (typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(() => setTimeout(run, 0));
  } else {
    setTimeout(run, 0);
  }
}

export function safeOpenChatwootWidget() {
  const run = () => {
    try {
      if (typeof window.$chatwoot?.toggle === "function") {
        window.$chatwoot.toggle("open");
      }
    } catch {
      // SDK not fully ready; ignore
    }
  };

  if (typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(() => setTimeout(run, 0));
  } else {
    setTimeout(run, 0);
  }
}
